// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

* {
  box-sizing: inherit;
}

.main-content {
  padding: 0;
  max-width: 100%;
}

@media (max-width: 768px) {
  .main-content {
    margin-top: 80px;
  }
}

.wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center; 
  min-height: 100vh;    
}

.form-container {
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  padding: 50px 40px;
  max-width: 1000px; /* POVEĆANO SA 450px */
  width: 100%;
  text-align: center;
}


.form-container h2 {
  font-size: 2rem;
  margin-bottom: 10px;
  color: #2b6cb0;
}

.form-container p {
  font-size: 1rem;
  color: #666;
  margin-bottom: 30px;
}

.form-container input[type="text"],
.form-container input[type="password"] {
  width: 100%;
  padding: 15px;
  border: 1px solid #cbd5e0;
  border-radius: 10px;
  font-size: 1rem;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.form-container button {
  background-color: #e53935;
  color: white;
  border: none;
  padding: 15px 50px;
  font-size: 1rem;
  border-radius: 50px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.form-container button:hover {
  background-color: #c62828;
}



.section {
  background-color: #f9fafb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.07);
  margin-bottom: 30px;
  padding: 30px;
  transition: box-shadow 0.3s ease;
}

.section {
  background-color: #f9fafb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.07);
  margin-bottom: 30px;
  padding: 30px;
  transition: box-shadow 0.3s ease;
  will-change: box-shadow;
}

.section:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}


.section-title {
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: #2b6cb0;
  border-bottom: 2px solid #e2e8f0;
  padding-bottom: 10px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

input[type="text"], input[type="number"], input[type="date"] {
  width: 100%;
  padding: 12px;
  border: 1px solid #cbd5e0;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 1rem;
}

input[type="checkbox"] {
  width: 20px;
  height: 20px;
}

button {
  background-color: #2b6cb0;
  color: white;
  border: none;
  padding: 15px 40px;
  font-size: 1rem;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #2c5282;
}

@media (max-width: 600px) {
  .form-container {
    padding: 20px;
  }
}

@media (max-width: 768px) {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background-color: #e1e1e2;
    color: white;
  }
}

/* Glavni layout koji zna za sidebar */
.layout {
  display: flex;
  flex-direction: row;
  min-height: 100vh;
}

.sidebar-desktop {
  width: 260px; /* širina sidebar-a (ili koliko već imaš) */
  background-color: #e1e1e2; /* samo ako testiraš lokalno */
}

/* Glavna zona */
.content-area {
  flex: 1 1;
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/* Mobilna verzija: sidebar nestaje, sadržaj uzima punu širinu */
@media (max-width: 768px) {
  .layout {
    flex-direction: column;
  }

  .sidebar-desktop {
    display: none;
  }

  .content-area {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/app.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB,EAAE,sBAAsB;EACzC,WAAW;EACX,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,YAAY;EACd;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY,EAAE,2CAA2C;EACzD,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,gEAAgE;AAChE;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["body, html {\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}\n\n.main-content {\n  padding: 0;\n  max-width: 100%;\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    margin-top: 80px;\n  }\n}\n\n.wrapper {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center; \n  min-height: 100vh;    \n}\n\n.form-container {\n  background-color: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\n  padding: 50px 40px;\n  max-width: 1000px; /* POVEĆANO SA 450px */\n  width: 100%;\n  text-align: center;\n}\n\n\n.form-container h2 {\n  font-size: 2rem;\n  margin-bottom: 10px;\n  color: #2b6cb0;\n}\n\n.form-container p {\n  font-size: 1rem;\n  color: #666;\n  margin-bottom: 30px;\n}\n\n.form-container input[type=\"text\"],\n.form-container input[type=\"password\"] {\n  width: 100%;\n  padding: 15px;\n  border: 1px solid #cbd5e0;\n  border-radius: 10px;\n  font-size: 1rem;\n  margin-bottom: 20px;\n  box-sizing: border-box;\n}\n\n.form-container button {\n  background-color: #e53935;\n  color: white;\n  border: none;\n  padding: 15px 50px;\n  font-size: 1rem;\n  border-radius: 50px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.form-container button:hover {\n  background-color: #c62828;\n}\n\n\n\n.section {\n  background-color: #f9fafb;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.07);\n  margin-bottom: 30px;\n  padding: 30px;\n  transition: box-shadow 0.3s ease;\n}\n\n.section {\n  background-color: #f9fafb;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.07);\n  margin-bottom: 30px;\n  padding: 30px;\n  transition: box-shadow 0.3s ease;\n  will-change: box-shadow;\n}\n\n.section:hover {\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);\n}\n\n\n.section-title {\n  font-size: 1.5rem;\n  margin-bottom: 20px;\n  color: #2b6cb0;\n  border-bottom: 2px solid #e2e8f0;\n  padding-bottom: 10px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n}\n\ninput[type=\"text\"], input[type=\"number\"], input[type=\"date\"] {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 8px;\n  box-sizing: border-box;\n  font-size: 1rem;\n}\n\ninput[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n}\n\nbutton {\n  background-color: #2b6cb0;\n  color: white;\n  border: none;\n  padding: 15px 40px;\n  font-size: 1rem;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\nbutton:hover {\n  background-color: #2c5282;\n}\n\n@media (max-width: 600px) {\n  .form-container {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    background-color: #e1e1e2;\n    color: white;\n  }\n}\n\n/* Glavni layout koji zna za sidebar */\n.layout {\n  display: flex;\n  flex-direction: row;\n  min-height: 100vh;\n}\n\n.sidebar-desktop {\n  width: 260px; /* širina sidebar-a (ili koliko već imaš) */\n  background-color: #e1e1e2; /* samo ako testiraš lokalno */\n}\n\n/* Glavna zona */\n.content-area {\n  flex: 1;\n  padding: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n/* Mobilna verzija: sidebar nestaje, sadržaj uzima punu širinu */\n@media (max-width: 768px) {\n  .layout {\n    flex-direction: column;\n  }\n\n  .sidebar-desktop {\n    display: none;\n  }\n\n  .content-area {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
